module.exports = __webpack_public_path__ + "media/svg-new/ic-doc-0906b08a.svg";